import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonContent,
  IonList,
  IonLoading,
  IonItem,
  IonText,
  IonLabel,
  IonTextarea,
  useIonViewWillEnter,
  useIonViewDidEnter,
  IonButton,
  IonToast,
  IonAlert,
  IonIcon,
  IonInput,
} from "@ionic/react";
import React, { useState } from "react";
import FaqItem from "../../../components/faqs/FaqItem";
import { useParams } from "react-router";
import axios from "axios";
import { requestID, baseUrl, config, getShopDetails } from "../../../common/utils";
import { useQuery } from "react-query";
import classes from "./AdminDashboard.module.css";
import {
  addCircle,
  addSharp,
  arrowBack,
  closeSharp,
  pencilSharp,
  personAddSharp,
  personCircleOutline,
  returnDownForward,
  saveSharp,
  trashBin,
} from "ionicons/icons";

const AdminFaqs = () => {
  const [status, setStatus] = useState({ loading: false, error: false });
  const [isOpen, setIsOpen] = useState(false);
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const [faqs, setFaqs] = useState([]);

  const handleSave = () => {
    setStatus({ loading: true, error: false });

    hideAddFaqsForm();

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("question", AddFaqsA.value);
    formData.append("answer", AddFaqsQ.value);

    axios
      .post(baseUrl() + "Faqsandterms/addfaq", formData, config)
      .then((response) => {
        console.log(response);

        //setSellerTerms(response.data.data);
        getFaqs();
        AddFaqsA.value = "";
        AddFaqsQ.value = "";

        //setSellerTermsx(response.data.data);
        setErrorLogin(response.data.message);
        callToast();
        setStatus({ loading: false, error: true });
      })
      .catch((error) => {
        setStatus({ loading: false, error: true });
        // throw new error("hey ");
      });
  };

  const handleUpdate = (idn) => {
    setStatus({ loading: true, error: false });
    hidehandleEdit(idn);
    const formData = new FormData();

    var ea = document.getElementById("ea" + idn);
    var eq = document.getElementById("eq" + idn);

    // console.log(eq.value + "  " + ea.value);

    formData.append("requestID", requestID());
    formData.append("question", ea.value);
    formData.append("answer", eq.value);
    formData.append("id", idn);

    axios
      .post(baseUrl() + "Faqsandterms/editfaq", formData, config)
      .then((response) => {
        getFaqs();
        console.log(response);

        //setSellerTerms(response.data.data);

        //setSellerTermsx(response.data.data);
        setErrorLogin(response.data.message);
        callToast();
        setStatus({ loading: false, error: true });
      })
      .catch((error) => {
        setStatus({ loading: false, error: true });
        // throw new error("hey ");
      });
  };

  const getFaqs = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());

    setStatus({ loading: true, error: false });

    axios
      .post(baseUrl() + "Faqsandterms/getAdminFaqs", formData, config)
      .then((response) => {
        console.log(response);
        setFaqs(response.data.data);
        if (response.data.staus == true) {
        } else {
          // setFaqs([]);
        }

        //setSellerTermsx(response.data.data);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  const delFaq = (ev) => {
    setStatus({ loading: true, error: false });
    //  var progressStaff1 = document.getElementById("progressStaff22");
    // progressStaff1.style.display = "block";
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("faqsID", ev);

    //  console.log(formData);

    axios
      .post(baseUrl() + "Faqsandterms/deletefaq", formData, config)
      .then((response) => {
        getFaqs();
        console.log(response);

        setStatus({ loading: false, error: true });
        setErrorLogin(response.data.message);
        callToast();
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  let counter = 1;

  const clearAddFaqsForm = () => {
    var addf = document.getElementById("AddFaqsForm");

    addf.value = "";
  };

  const hidehandleEdit = (idn) => {
    console.log(idn);

    var rform = document.getElementById("real" + idn);
    rform.style.display = "block";

    var eform = document.getElementById("edit" + idn);
    eform.style.display = "none";
  };

  const handleEdit = (idn) => {
    //console.log(idn);

    var rform = document.getElementById("real" + idn);
    rform.style.display = "none";

    var eform = document.getElementById("edit" + idn);
    eform.style.display = "block";
  };

  const showAddFaqsForm = () => {
    var addf = document.getElementById("AddFaqsForm");

    addf.style.display == "block"
      ? (addf.style.display = "none")
      : (addf.style.display = "block");

    var faqsAddBtn = document.getElementById("faqsAddBtn");
    faqsAddBtn.style.display = "none";
  };
  const hideAddFaqsForm = () => {
    var addf = document.getElementById("AddFaqsForm");
    addf.style.display = "none";

    var faqsAddBtn = document.getElementById("faqsAddBtn");
    faqsAddBtn.style.display = "block";
  };
  useIonViewWillEnter(() => {
    hideAddFaqsForm();
    getFaqs();
  });

  /*  useIonViewDidEnter(() => {
    console.log("sds2");
    getSellerTerms();
  }); */
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="">
            <IonBackButton text="" icon={arrowBack} className="zillytheme2" />
          </IonButtons>
          <IonTitle>FAQs Setup</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonItem
            className="zillyItemx"
            detail={false}
            lines="none"
            onClick={showAddFaqsForm}
            id="faqsAddBtn"
          >
            <IonButton
              color="warning"
              mode="md"
              size="large"
              className="zillyButtonx"
              fill="solid"
            >
              <IonIcon slot="start" icon={addSharp}></IonIcon>
              Add New
            </IonButton>
          </IonItem>
          {/* <IonItem lines="none">
            <IonButton
              onClick={showAddFaqsForm}
              slot="end"
              className={classes.faqsAddBtn}
              expand="block"
              color="success"
              id="faqsAddBtn"
            >
              <IonIcon slot="start" icon={addSharp}></IonIcon>
              Add New
            </IonButton>
          </IonItem> */}

          {/*   <IonAlert
            trigger="faqsAddBtn"
            header="Please enter your info"
            buttons={[
              {
                text: "Cancel",
                role: "cancel",
                handler: () => {
                  console.log("Alert canceled");
                },
              },
              {
                text: "Add",
                role: "confirm",
                handler: () => {
                  console.log(faqs.id);
                  // removeStaff(faqs.user_id);
                },
              },
            ]}
            inputs={[
              {
                placeholder: "Question",
              },

              {
                placeholder: "Answer (max 100 characters)",
                type: "textarea",
                rows: "200",
                attributes: {
                  maxlength: 400,
                },
              },
            ]}
          ></IonAlert> */}
          <div id="AddFaqsForm" className={`classes.AddFaqsFormx`}>
            <IonItem lines="none" className={`zillyBoxc cclasses.AddFaqsFormx`}>
              <IonInput placeholder="Question" id="AddFaqsQ">
                {" "}
              </IonInput>{" "}
            </IonItem>
            <IonItem className={`zillyBoxc classes.AddFaqsFormx`} lines="none">
              {" "}
              <IonTextarea id="AddFaqsA" rows="5" placeholder="Answer">
                {" "}
              </IonTextarea>
            </IonItem>{" "}
            {/* <IonItem lines="none">
              <IonButton
                onClick={handleSave}
                slot="end"
                className={classes.faqsAddBtn}
                expand="block"
                color="success"
              >
                <IonIcon slot="start" icon={addSharp}></IonIcon>
                Save
              </IonButton>
            </IonItem> */}
            <IonItem
              className="zillyItemx"
              detail={false}
              lines="none"
              onClick={handleSave}
            >
              <IonButton
                color="warning"
                mode="md"
                size="large"
                className="zillyButtonx"
                fill="solid"
              >
                <IonIcon slot="start" icon={addSharp}></IonIcon>
                Save
              </IonButton>
            </IonItem>
          </div>

          {faqs &&
            faqs.map((faqs, i) => {
              return (
                <IonList>
                  <IonList
                    className="zillyBoxc"
                    id={"real" + faqs.id}
                    key={i}
                  >
                    <IonItem lines="none" className="">
                      <IonItem lines="none">
                        <p>
                          {i + 1} . {faqs.question} ??
                        </p>
                      </IonItem>
                      <IonIcon
                        onClick={(ev) => handleEdit(faqs.id)}
                        className={classes.termsIcon2}
                        slot="end"
                        icon={pencilSharp}
                      ></IonIcon>
                      <IonIcon
                        id={faqs.id}
                        className={classes.termsIcon2}
                        slot="end"
                        mode="ios"
                        icon={closeSharp}
                      ></IonIcon>
                      <IonAlert
                        header={"Do you want to delete this question ? "}
                        trigger={faqs.id}
                        buttons={[
                          {
                            text: "Cancel",
                            role: "cancel",
                            handler: () => {
                              console.log("Alert canceled");
                            },
                          },
                          {
                            text: "Delete",
                            role: "confirm",
                            handler: () => {
                              console.log(faqs.id);
                              delFaq(faqs.id);
                            },
                          },
                        ]}
                        onDidDismiss={({ detail }) =>
                          console.log(`Dismissed with role: ${detail.role}`)
                        }
                      ></IonAlert>
                    </IonItem>
                    <IonItem lines="none">
                      <IonIcon
                        // className={classes.termsIcon2}
                        slot="start"
                        mode="ios"
                        icon={returnDownForward}
                      ></IonIcon>
                      {/* <p>{faqs.question}</p> */}
                      <span className={classes.termsQuestion}>
                        {faqs?.answer}
                      </span>{" "}
                    </IonItem>
                  </IonList>
                  <IonList
                    className={classes.hidefaqsx}
                    id={"edit" + faqs.id}
                    key={"edit" + faqs.id}
                  >
                    <IonItem lines="none">
                      <IonTextarea
                        id={"ea" + faqs.id}
                        value={faqs.question}
                      ></IonTextarea>{" "}
                    </IonItem>

                    <IonItem className="zillyBoxc" lines="none">
                      <IonIcon
                        id={faqs.id}
                        onClick={(ev) => handleUpdate(faqs.id)}
                        className={classes.termsIcon2}
                        slot="end"
                        mode="ios"
                        icon={saveSharp}
                      ></IonIcon>

                      <IonInput
                        id={"eq" + faqs.id}
                        value={faqs.answer}
                      ></IonInput>
                    </IonItem>
                  </IonList>
                </IonList>
              );
            })}
        </IonList>
      </IonContent>
      {status.error && (
        <IonToast position="middle" isOpen={showToast} message={errorLogin} />
      )}
      <IonLoading isOpen={status.loading} />
    </IonPage>
  );
};

export default AdminFaqs;
